import React, { useState, useEffect } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { loadUser, signOut } from "src/redux/actions";
import { apiSignOut, apiGetOrganizationDetails } from "src/api";
import clsx from "clsx";
import _ from "lodash";
import {
  AppBar,
  Box,
  Hidden,
  IconButton,
  Toolbar,
  InputBase,
  makeStyles,
  Button,
} from "@material-ui/core";
import { alpha } from "@material-ui/core/styles";
import MenuIcon from "@material-ui/icons/Menu";
import InputIcon from "@material-ui/icons/Input";
import { GiMoneyStack } from "react-icons/gi";
import { useSnackbar } from "notistack";
import SearchIcon from "@material-ui/icons/Search";
import { useTranslation } from "react-i18next";
import { urlAPIConf } from "src/config/api";
import SystemNotification from "src/components/systemNotification";
import { UserAvatar } from "./NavBar";
// import ThemeChange from "./themeChange";
import { NotificationBox } from "./notifications";
import { LanguageSelect } from "./languageSelect";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.primary.main,
    height: "64px",
  },
  toolbar: {
    height: "100%",
    minHeight: "70px",
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(1),
  },
  settingsButton: {
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
  },
  popover: {
    "& svg": {
      color: "white !important",
    },
    backgroundColor: theme.palette.primary.main,
  },
  logoWrapper: {
    color: "white !important",
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    justifyContent: "flex-start",
    marginTop: "0px",
    paddingTop: "0px",
    "& img": {
      maxHeight: "65px",
      maxWidth: "750px",
      marginRight: "8px",
      marginLeft: "10px",
      paddingBottom: "6px",
      marginBottom: "0px",
    },
    "& .logotype": {
      marginLeft: "8px",
      display: "inline-flex",
      textDecoration: "none",
      color: "#FFF !important",
      fontSize: "25px",
      fontWeight: "400",
    },
  },
  avatar: {
    width: 60,
    height: 60,
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    color: "white",
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    marginTop: "4px",
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(0),
      marginRight: theme.spacing(2),
      width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  signOutButton: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    color: theme.palette.common.white,
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.15),
    },
    "& svg": {
      color: theme.palette.common.white,
    },
  },
  inputInput: {
    padding: theme.spacing(0.7, 1, 0.7, 1),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
  balanceButton: {
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0),
    marginTop: theme.spacing(0.3),
    color: theme.palette.common.white,
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.15),
    },
    "& svg": {
      color: theme.palette.common.white,
    },
  },
}));

function mapDispatchToPropsSignOut(dispatch) {
  return {
    signOut: () => dispatch(signOut()),
    loadUser: () => dispatch(loadUser()),
  };
}

const ConnectedSignOutButton = (props) => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const signOutHandler = () => {
    apiSignOut((data, status) => {
      if (status === 200) {
        enqueueSnackbar("Successfully signed out", { variant: "success" });
        props.signOut();
        props.loadUser(null);
      } else {
        // error
        enqueueSnackbar(data, { variant: "alert" });
      }
    });
  };

  return (
    <Button
      endIcon={<InputIcon />}
      color="inherit"
      className={props.classes.signOutButton}
      onClick={signOutHandler}
      style={{
        marginRight: "5px",
        marginLeft: "0px",
        fontSize: "12px",
        marginTop: "3px",
      }}
    >
      {t("Sign out")}
    </Button>
  );
};

export const SignOutButton = connect(
  null,
  mapDispatchToPropsSignOut
)(ConnectedSignOutButton);

const mapStateToProps = (state) => {
  return {
    appConf: state.appConf,
    userObject: state.userObject,
  };
};

const ConnectedTopBar = (props) => {
  const { className, onMobileNavOpen, appConf, userObject } = props;
  const classes = useStyles();
  const navigate = useNavigate();
  const [organizationData, setOrganizationData] = useState(undefined);
  const [showSystemNotification, setShowSystemNotification] = useState(
    appConf.system_notification &&
      appConf.system_notification.id !==
        userObject.settings.general.hideSystemNotification
  );
  const { t } = useTranslation();

  useEffect(() => {
    let mounted = true;
    if (userObject?.activeOrganization?.id) {
      apiGetOrganizationDetails(
        userObject.activeOrganization.id,
        (data, status) => {
          if (status === 200 && mounted) {
            setOrganizationData(data);
          }
        }
      );
    }
    return () => {
      mounted = false;
    };
  }, [userObject]);

  useEffect(() => {
    if (appConf && userObject) {
      setShowSystemNotification(
        appConf.system_notification &&
          appConf.system_notification.id !==
            userObject.settings.general.hideSystemNotification
      );
    }
  }, [appConf, userObject]);

  const searchSubmitHandler = (event) => {
    event.preventDefault();
    const query = event.target[0].value.replace(" ", "+");
    event.target[0].value = "";
    navigate(
      `/${urlAPIConf.PROJECTS_SLUG}/?filterValue={}&value=${query}&page=0&pageSize=10&value=&&sort={"created_at":"DESC"}`
    );
  };

  return (
    <AppBar className={clsx(classes.root, className)} elevation={0}>
      <Toolbar className={classes.toolbar}>
        <Hidden lgUp>
          <IconButton color="inherit" onClick={onMobileNavOpen}>
            <MenuIcon />
          </IconButton>
        </Hidden>
        <RouterLink to="/" className={classes.logoWrapper}>
          <img alt="Logo" src="/exomeLogoWhite.png" />
        </RouterLink>
        <Box flexGrow={1} />
        <Hidden mdDown>
          <UserAvatar />
          <form className={classes.search} onSubmit={searchSubmitHandler}>
            <div className={classes.searchIcon}>
              <SearchIcon />
            </div>
            <InputBase
              placeholder={t("Search…")}
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput,
              }}
              inputProps={{
                "aria-label": "search",
              }}
            />
          </form>
          <NotificationBox userObject={userObject} />
          <LanguageSelect />
          {/* <ThemeChange /> */}
          {/* <Settings
            classes={classes}
            searchSubmitHandler={searchSubmitHandler}
            userObject={userObject}
          /> */}
          {organizationData && _.isNumber(organizationData.credit_balance) && (
            <Button
              startIcon={<GiMoneyStack />}
              className={classes.balanceButton}
              onClick={() => navigate("/account/transactions")}
            >
              {organizationData.credit_balance}
            </Button>
          )}
          <SignOutButton classes={classes} />
        </Hidden>
      </Toolbar>
      {showSystemNotification && (
        <SystemNotification
          id={appConf.system_notification.id}
          message={appConf.system_notification.message}
          kind={appConf?.system_notification?.kind}
          isPersistent={appConf.system_notification.is_persistent}
        />
      )}
    </AppBar>
  );
};

const TopBar = connect(mapStateToProps)(ConnectedTopBar);

export default TopBar;
